export default __webpack_public_path__ + "static/media/notifications.e14352a6.svg";